export default __webpack_public_path__ + "static/media/linear-white-gradient-blue-1920x1080-c2-b0c4de-fff5ee-a-60-f-14.7a373f4d.svg";